import { render, staticRenderFns } from "./CentersPage.vue?vue&type=template&id=5320d84c&scoped=true"
import script from "./CentersPage.vue?vue&type=script&lang=js"
export * from "./CentersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5320d84c",
  null
  
)

export default component.exports